import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Zap, Clock } from 'lucide-react';
export function Pricing() {
  const [selectedOffer, setSelectedOffer] = useState<'A' | 'B'>('A');
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  // Countdown logic
  useEffect(() => {
    const endTimeKey = 'trauma_offer_end_time';
    const getEndTime = () => {
      const stored = localStorage.getItem(endTimeKey);
      if (stored) {
        const parsed = parseInt(stored, 10);
        if (!isNaN(parsed) && parsed > Date.now()) {
          return parsed;
        }
      }
      const newEndTime = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem(endTimeKey, newEndTime.toString());
      return newEndTime;
    };
    const tick = () => {
      const endTime = getEndTime();
      const distance = endTime - Date.now();
      const safeDistance = distance > 0 ? distance : 0;
      setTimeLeft({
        hours: Math.floor(safeDistance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(safeDistance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(safeDistance % (1000 * 60) / 1000)
      });
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const handlePurchase = () => {
    const url = selectedOffer === 'A' ? 'https://checkout.ebookpoint.shop/cart/59600811393105:1' : 'https://checkout.ebookpoint.shop/cart/59600840949841:1';
    window.location.href = url;
  };
  return <section id="compra" className="py-20 bg-navy-900 text-white px-4" data-id="element-146">
      <div className="max-w-4xl mx-auto" data-id="element-147">
        {/* Countdown */}
        <div className="text-center mb-10" data-id="element-148">
          <div className="inline-flex items-center gap-2 bg-red-500/20 text-red-300 px-4 py-2 rounded-full font-medium mb-4 border border-red-500/30" data-id="element-149">
            <Clock size={18} data-id="element-150" />
            <span data-id="element-151">La oferta termina en:</span>
            <span className="font-mono font-bold tracking-wider" data-id="element-152">
              {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-153">
            Elegí tu plan de estudio
          </h2>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8" data-id="element-154">
          {/* Option A */}
          <div onClick={() => setSelectedOffer('A')} className={`cursor-pointer rounded-2xl p-6 border-2 transition-all relative ${selectedOffer === 'A' ? 'bg-navy-800 border-gold-500 shadow-[0_0_20px_rgba(245,158,11,0.2)]' : 'bg-navy-800/50 border-navy-700 hover:border-navy-600'}`} data-id="element-155">
            <div className="flex justify-between items-start mb-4" data-id="element-156">
              <div data-id="element-157">
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-158">
                  Manual de Traumatología Resuelta
                </h3>
                <p className="text-slate-400 text-sm line-through" data-id="element-159">$52.690</p>
                <div className="text-3xl font-extrabold text-gold-400" data-id="element-160">
                  $19.899
                </div>
              </div>
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOffer === 'A' ? 'border-gold-500 bg-gold-500' : 'border-slate-500'}`} data-id="element-161">
                {selectedOffer === 'A' && <Check size={14} className="text-navy-900 font-bold" data-id="element-162" />}
              </div>
            </div>

            <ul className="space-y-3 mt-6" data-id="element-163">
              <li className="flex items-start gap-2 text-sm text-blue-100" data-id="element-164">
                <Check size={16} className="text-gold-500 shrink-0 mt-0.5" data-id="element-165" />
                <span data-id="element-166">7 Capítulos completos</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-blue-100" data-id="element-167">
                <Check size={16} className="text-gold-500 shrink-0 mt-0.5" data-id="element-168" />
                <span data-id="element-169">5 Bonos Gratis</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-blue-100" data-id="element-170">
                <Check size={16} className="text-gold-500 shrink-0 mt-0.5" data-id="element-171" />
                <span data-id="element-172">Acceso de por vida</span>
              </li>
            </ul>
          </div>

          {/* Option B */}
          <div onClick={() => setSelectedOffer('B')} className={`cursor-pointer rounded-2xl p-6 border-2 transition-all relative ${selectedOffer === 'B' ? 'bg-navy-800 border-gold-500 shadow-[0_0_20px_rgba(245,158,11,0.2)]' : 'bg-navy-800/50 border-navy-700 hover:border-navy-600'}`} data-id="element-173">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold-500 text-navy-900 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-174">
              MÁS ELEGIDO
            </div>
            <div className="flex justify-between items-start mb-4" data-id="element-175">
              <div data-id="element-176">
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-177">
                  Manual de Traumatología Resuelta PRO
                </h3>
                <div className="text-3xl font-extrabold text-gold-400 mt-5" data-id="element-178">
                  $27.990
                </div>
              </div>
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOffer === 'B' ? 'border-gold-500 bg-gold-500' : 'border-slate-500'}`} data-id="element-179">
                {selectedOffer === 'B' && <Check size={14} className="text-navy-900 font-bold" data-id="element-180" />}
              </div>
            </div>

            <ul className="space-y-3 mt-6" data-id="element-181">
              <li className="flex items-start gap-2 text-sm text-blue-100" data-id="element-182">
                <Check size={16} className="text-gold-500 shrink-0 mt-0.5" data-id="element-183" />
                <span data-id="element-184">Todo lo incluido en la oferta principal</span>
              </li>
              <li className="flex items-start gap-2 text-sm font-bold text-gold-300" data-id="element-185">
                <Check size={16} className="text-gold-500 shrink-0 mt-0.5" data-id="element-186" />
                <span data-id="element-187">Bono ELITE: Mapa visual del Capítulo 2</span>
              </li>
              <li className="flex items-start gap-2 text-sm font-bold text-gold-300" data-id="element-188">
                <Check size={16} className="text-gold-500 shrink-0 mt-0.5" data-id="element-189" />
                <span data-id="element-190">
                  Bono ELITE: Manual de semiología gráfico y práctico +200
                  páginas
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center" data-id="element-191">
          <button onClick={handlePurchase} className="w-full md:w-auto px-10 py-5 bg-gold-500 hover:bg-gold-400 text-navy-900 font-extrabold text-xl rounded-xl shadow-[0_0_20px_rgba(245,158,11,0.4)] hover:shadow-[0_0_30px_rgba(245,158,11,0.6)] transition-all transform hover:-translate-y-1 mb-6" data-id="element-192">
            🔒 Quiero mi Manual ahora
          </button>

          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center gap-6 text-sm text-blue-200" data-id="element-193">
            <div className="flex items-center gap-2" data-id="element-194">
              <ShieldCheck size={18} className="text-green-400" data-id="element-195" />
              <span data-id="element-196">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-197">
              <Zap size={18} className="text-gold-400" data-id="element-198" />
              <span data-id="element-199">Acceso Inmediato</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}